import React, { Fragment, useContext, useState } from "react";
import propTypes from "prop-types";
import { api, Category } from "../../../../logic/api";
import styles from "./styles";

import {
    FiChevronRight,
    FiEdit,
    FiFolder,
} from 'react-icons/fi';

import flex from "../../../../styles/flex";
import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { isSysAdmin } from "../../../../utility/utils";
import { SessionContext } from "../../../../utility/useSession";
import TextInputField from "../../../editable/EditableField/fields/TextInputField";
import ErrorDialog from "../../../notifications/errorDialog/ErrorDialog";
import { useTranslation } from "react-i18next";

const CategoryListItem: React.FunctionComponent<{
    item: Category,
    onClick: () => void
}> = (props) => {

    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const [showEditCategory, setShowEditCategory] = useState(false);
    const [rename, setRename] = useState(props.item.categoryName);
    const [updatedName, setUpdatedName] = useState(props.item.categoryName);

    const renameCategory = api.hooks.category.rename();


    const confirmRenameCategory = async () => {
        setShowEditCategory(false);
        renameCategory.send(session.current.context, {
            name: rename,
            id: props.item.id
        }, (result) => {
            if (result != null) {
                setUpdatedName(rename);
            }
        });
    }
    const isSystemUIReport = props.item.categoryName.startsWith("#");

    const border = isSystemUIReport ? styles.borderSystem : styles.border;
    return (
        <Fragment>
            <ErrorDialog err={renameCategory.err}></ErrorDialog>
            <Dialog
                open={showEditCategory}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{t("lists.renameCategory")}</DialogTitle>
                <DialogContent>
                    <div style={{ paddingTop: 10 }}>
                        <TextInputField label={t("lists.categoryName")} value={rename} onChange={(value) => {
                            setRename(value);
                        }} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowEditCategory(false)} color="secondary">{t("general.cancel")}</Button>
                    <Button disabled={rename.length == 0 || rename == updatedName} onClick={() => confirmRenameCategory()} color="primary">{t("general.apply")}</Button>
                </DialogActions>
            </Dialog>
            <div style={{ ...styles.listItem, ...border }} >
                <div style={styles.listItemFlex}>
                    <ListViewItemCard
                        icon={isSystemUIReport ? <FiFolder style={{ ...styles.icon, color: "orange" }} /> : <FiFolder style={styles.icon} />}
                        text={updatedName}
                        subText={isSystemUIReport ? t("lists.uiSysReport") : ""}
                        onClick={() => {
                            if (props.onClick != null) {
                                props.onClick();
                            }
                        }}
                    />
                    {isSysAdmin(session) && (
                        <Fragment>
                            <div style={flex.flexAuto} onMouseDown={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowEditCategory(true);
                                return false;
                            }}>
                                <IconButton>
                                    <FiEdit />
                                </IconButton>
                            </div>
                        </Fragment>
                    )}

                    <div style={flex.flexAuto}>
                        <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                            <div style={flex.flexAuto}>
                                <FiChevronRight style={styles.iconChevron} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


CategoryListItem.propTypes = {
    item: propTypes.any.isRequired,
    onClick: propTypes.func.isRequired

};


export default CategoryListItem;